import React from 'react';

import Icon, { Props } from './icon';

export const PlayIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.8311 19.9035L12.0519 35.6397C11.3871 36.0797 10.5 35.603 10.5 34.8058V5.08179C10.5 4.30837 11.3404 3.82772 12.007 4.21986L35.7862 18.2076C36.4235 18.5825 36.4477 19.4954 35.8311 19.9035Z"
          fill="#F2F2F2"
        />
      </svg>
    </Icon>
  );
};

export default React.memo(PlayIcon);
